/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkUpdateLeadSOffenderRecordsRequest
 */
export interface BulkUpdateLeadSOffenderRecordsRequest {
    /**
     * 
     */
    ids: Array<string>;
    /**
     * 
     */
    is_dismissed: boolean;
}

/**
 * Check if a given object implements the BulkUpdateLeadSOffenderRecordsRequest interface.
 */
export function instanceOfBulkUpdateLeadSOffenderRecordsRequest(value: object): value is BulkUpdateLeadSOffenderRecordsRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('is_dismissed' in value) || value['is_dismissed'] === undefined) return false;
    return true;
}

export function BulkUpdateLeadSOffenderRecordsRequestFromJSON(json: any): BulkUpdateLeadSOffenderRecordsRequest {
    return BulkUpdateLeadSOffenderRecordsRequestFromJSONTyped(json, false);
}

export function BulkUpdateLeadSOffenderRecordsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUpdateLeadSOffenderRecordsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'is_dismissed': json['is_dismissed'],
    };
}

export function BulkUpdateLeadSOffenderRecordsRequestToJSON(json: any): BulkUpdateLeadSOffenderRecordsRequest {
    return BulkUpdateLeadSOffenderRecordsRequestToJSONTyped(json, false);
}

export function BulkUpdateLeadSOffenderRecordsRequestToJSONTyped(value?: BulkUpdateLeadSOffenderRecordsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'is_dismissed': value['is_dismissed'],
    };
}

